/**
 * Checkout's binding of the shared chat widget.
 *
 * The loader, the restore rule and the SDK hand-off live in `pb-chat-widget`,
 * which checkout, hive and the partners portal all mount. What is app-specific
 * is only where the two runtime values come from — the `public.pb` config and
 * the request-scoped shared flag — so that is all this file supplies. Both are
 * read inside a function, at call time, because they need the Nuxt instance an
 * await or a module-level read would not have.
 *
 * The named exports below are checkout's published surface: the auth store and
 * the launcher reach chat through them. `supportChat` is the same object, handed
 * whole to the launcher component, which needs the bound API rather than the
 * loose functions.
 */
import { defineChatWidget, type ChatWidgetPublicConfig } from 'pb-chat-widget';

export const supportChat = defineChatWidget({
    config: () => useRuntimeConfig().public.pb as ChatWidgetPublicConfig,
    sharedFlag: (key) => useState<boolean>(key, () => false),
    dev: import.meta.dev,
});

export const {
    chatWidgetEnvironment,
    loadChatWidget,
    useSdkOwnsLauncher,
    openSupportChat,
    hasExistingConversation,
    restoreSupportChat,
    resetSupportChat,
} = supportChat;

export {
    SDK_HOST_ID,
    notifySupportChatIdentityChanged,
    tearDownSdkWidget,
} from 'pb-chat-widget';

export type { ChatWidgetEnvironment } from 'pb-chat-widget';
